// basement_options_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mainToggle", "optionsContainer", "option"];

  connect() {
    console.debug("Basement Options Controller connected");
    this.checkOptions();
  }

  toggle(event) {
    try {
      const isChecked = this.mainToggleTarget.checked;
      console.debug("Main toggle changed:", isChecked);

      this.optionsContainerTarget.classList.toggle("hidden", !isChecked);

      if (!isChecked) {
        this.optionTargets.forEach((option) => {
          option.checked = false;
        });
        console.debug("All options cleared");
      }
    } catch (error) {
      console.error("Error in toggle:", error);
    }
  }

  checkOptions() {
    try {
      const hasSelectedOptions = this.optionTargets.some(
        (option) => option.checked,
      );
      console.debug("Has selected options:", hasSelectedOptions);

      this.mainToggleTarget.checked = hasSelectedOptions;
      this.optionsContainerTarget.classList.toggle(
        "hidden",
        !hasSelectedOptions,
      );
    } catch (error) {
      console.error("Error in checkOptions:", error);
    }
  }

  // Add a method to handle individual option changes
  optionChanged() {
    this.checkOptions();
  }
}
